import { render, staticRenderFns } from "./ProfessorLicenses.vue?vue&type=template&id=9bba86be&scoped=true&"
import script from "./ProfessorLicenses.vue?vue&type=script&lang=js&"
export * from "./ProfessorLicenses.vue?vue&type=script&lang=js&"
import style0 from "./ProfessorLicenses.vue?vue&type=style&index=0&id=9bba86be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bba86be",
  null
  
)

export default component.exports